import { Section } from 'utils/types/contentfulTypes';

import { MedicalConciergeProps } from './MedicalConcierge';

export const parseMedicalConcierge = (
  contentfulSection: Section,
): MedicalConciergeProps | null => {
  const { eyebrow, images } = contentfulSection;

  const { theme, title } = contentfulSection.metadata || {};

  const MedicalConciergeProps = {
    eyebrow,
    title,
    images: images || [],
    theme: {
      textColor: theme?.textColor || 'viridian.base',
      backgroundColor: theme?.backgroundColor || 'tints.lightCream',
    },
  };

  return MedicalConciergeProps;
};
